import { Row, Col } from "react-bootstrap";
import { InputBox, Button } from "../../Common";
import styles from "./plan.module.css";
import DropDown from "../../Common/DropDown/index";

const currencyOptions = ["INR", "USD"];
const frequencyOptions = ["DAILY", "WEEKLY", "MONTHLY", "YEARLY"];

const currencyFormatValue = (val) => {
  if (!val) return "";
  if (typeof val === "object") val = val.label ?? val.value ?? "";
  return val;
};
const CreatePlanForm = ({
  mode,
  formData,
  errors,
  currentStep,
  successMessage,
  loading,
  onChange,
  onDropdownChange,
  onNextStep,
  onPreviousStep,
  onSubmit,
}) => {
  const renderStepOne = () => (
    <div className={styles.stepContainer}>
      <div className={styles.stepHeader}>
        <h3>
          {mode === "create" ? "Create Plan" : "Update Plan"} - Basic
          Information
        </h3>
      </div>

      <Row className="mb-4">
        <Col md={4} className={styles.inputDiv}>
          <label>
            Plan Code <span className={styles.required}>*</span>
            <InputBox
              placeholder="Enter Plan Code"
              type="text"
              name="code"
              onChange={onChange}
              value={formData.code}
              disabled={mode === "update"}
            />
            {errors.code && (
              <p className={styles.errorMessage}>{errors.code}</p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <label>
            Plan Name <span className={styles.required}>*</span>
            <InputBox
              placeholder="Enter Plan Name"
              type="text"
              name="name"
              onChange={onChange}
              value={formData.name}
            />
            {errors.name && (
              <p className={styles.errorMessage}>{errors.name}</p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <label>
            Subscription Amount
            <InputBox
              placeholder="Enter Amount"
              type="text"
              name="subscriptionAmt"
              onChange={onChange}
              value={formData.subscriptionAmt}
            />
            {errors.subscriptionAmt && (
              <p className={styles.errorMessage}>{errors.subscriptionAmt}</p>
            )}
          </label>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={4} className={styles.inputDiv}>
          <label>
            Account Opening Fees
            <InputBox
              placeholder="Enter Account Opening Fees"
              type="text"
              name="acctOpenFeesAmt"
              onChange={onChange}
              value={formData.acctOpenFeesAmt}
            />
            {errors.acctOpenFeesAmt && (
              <p className={styles.errorMessage}>{errors.acctOpenFeesAmt}</p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <DropDown
            label="Currency"
            name="currencyCd"
            value={formData.currencyCd}
            data={currencyOptions}
            onChange={(val) => onDropdownChange("currencyCd", val)}
            placeholder="Select Currency"
            required={true}
            error={!!errors.currencyCd}
            helperText={errors.currencyCd}
            formatValue={currencyFormatValue}
          />
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <label>
            Trade Commission Amount
            <InputBox
              placeholder="Enter Amount"
              type="text"
              name="tradeCommissionAmt"
              onChange={onChange}
              value={formData.tradeCommissionAmt}
            />
            {errors.tradeCommissionAmt && (
              <p className={styles.errorMessage}>{errors.tradeCommissionAmt}</p>
            )}
          </label>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={4} className={styles.inputDiv}>
          <label>
            Order Quantity Limit
            <InputBox
              placeholder="Enter Order Quantity Limit"
              type="text"
              name="orderQtyLimit"
              onChange={onChange}
              value={formData.orderQtyLimit}
            />
            {errors.orderQtyLimit && (
              <p className={styles.errorMessage}>{errors.orderQtyLimit}</p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <label>
            Plan Sequence <span className={styles.required}>*</span>
            <InputBox
              placeholder="Enter Plan Sequence"
              type="text"
              name="planSeq"
              onChange={onChange}
              value={formData.planSeq}
            />
            {errors.planSeq && (
              <p className={styles.errorMessage}>{errors.planSeq}</p>
            )}
          </label>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={12} className={styles.inputDiv}>
          <label>
            Fee Description
            <textarea
              placeholder="Enter Fee Description"
              name="feeDesc"
              className={styles.textArea}
              onChange={onChange}
              value={formData.feeDesc}
            />
            {errors.feeDesc && (
              <p className={styles.errorMessage}>{errors.feeDesc}</p>
            )}
          </label>
        </Col>
      </Row>

      <Row style={{ marginTop: "30px" }}>
        <Col md={12} className={styles.buttonContainer}>
          <div className={styles.centeredButtons}>
            <Button
              onClick={onNextStep}
              title="Next Step"
              style={{ minWidth: "120px" }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );

  const renderStepTwo = () => (
    <div className={styles.stepContainer}>
      <div className={styles.stepHeader}>
        <h3>
          {mode === "create" ? "Create Plan" : "Update Plan"} - Additional
          Details
        </h3>
      </div>

      <Row className="mb-4">
        <Col md={4} className={styles.inputDiv}>
          <label>
            Share Commission Amount
            <InputBox
              placeholder="Enter Amount"
              type="text"
              name="shareCommissionAmt"
              onChange={onChange}
              value={formData.shareCommissionAmt}
            />
            {errors.shareCommissionAmt && (
              <p className={styles.errorMessage}>{errors.shareCommissionAmt}</p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <label>
            AUM Commission Percentage
            <InputBox
              placeholder="Enter AUM Commission %"
              type="text"
              name="aumCommissionPct"
              onChange={onChange}
              value={formData.aumCommissionPct}
            />
            {errors.aumCommissionPct && (
              <p className={styles.errorMessage}>{errors.aumCommissionPct}</p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <label>
            Minimum Commission Amount
            <InputBox
              placeholder="Enter Amount"
              type="text"
              name="minCommissionAmt"
              onChange={onChange}
              value={formData.minCommissionAmt}
            />
            {errors.minCommissionAmt && (
              <p className={styles.errorMessage}>{errors.minCommissionAmt}</p>
            )}
          </label>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={4} className={styles.inputDiv}>
          <label>
            Free Trades
            <InputBox
              placeholder="Enter Free Trades"
              type="text"
              name="freeTrades"
              onChange={onChange}
              value={formData.freeTrades}
            />
            {errors.freeTrades && (
              <p className={styles.errorMessage}>{errors.freeTrades}</p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <label>
            Free Trades Quantity
            <InputBox
              placeholder="Enter Free Trades Quantity"
              type="text"
              name="freeTradesQty"
              onChange={onChange}
              value={formData.freeTradesQty}
            />
            {errors.freeTradesQty && (
              <p className={styles.errorMessage}>{errors.freeTradesQty}</p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <DropDown
            label="Free Trades Frequency"
            name="freeTradesFreqCd"
            value={formData.freeTradesFreqCd}
            data={frequencyOptions}
            onChange={(val) => onDropdownChange("freeTradesFreqCd", val)}
            placeholder="Select Frequency"
            required={false}
            error={!!errors.freeTradesFreqCd}
            helperText={errors.freeTradesFreqCd}
          />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={4} className={styles.inputDiv}>
          <label>
            Hotline Support Phone
            <InputBox
              placeholder="Enter Hotline Support Phone"
              type="text"
              name="hotlineSupportPhone"
              onChange={onChange}
              value={formData.hotlineSupportPhone}
            />
            {errors.hotlineSupportPhone && (
              <p className={styles.errorMessage}>
                {errors.hotlineSupportPhone}
              </p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <label>
            Plan Title Amount
            <InputBox
              placeholder="Enter Amount"
              type="text"
              name="planTitleAmount"
              onChange={onChange}
              value={formData.planTitleAmount}
            />
            {errors.planTitleAmount && (
              <p className={styles.errorMessage}>{errors.planTitleAmount}</p>
            )}
          </label>
        </Col>
        <Col md={4} className={styles.inputDiv}>
          <label>
            Plan Title Adjacent
            <InputBox
              placeholder="Enter Plan Title Adjacent"
              type="text"
              name="planTitleAdjacent"
              onChange={onChange}
              value={formData.planTitleAdjacent}
            />
            {errors.planTitleAdjacent && (
              <p className={styles.errorMessage}>{errors.planTitleAdjacent}</p>
            )}
          </label>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={6} className={styles.inputDiv}>
          <label>
            Stock Scope
            <textarea
              placeholder="Enter Stock Scope"
              name="stockScope"
              className={styles.textArea}
              onChange={onChange}
              value={formData.stockScope}
            />
            {errors.stockScope && (
              <p className={styles.errorMessage}>{errors.stockScope}</p>
            )}
          </label>
        </Col>
        <Col md={6} className={styles.inputDiv}>
          <label>
            Hotline Support Text
            <textarea
              placeholder="Enter Hotline Support Text"
              name="hotlineSupportText"
              className={styles.textArea}
              onChange={onChange}
              value={formData.hotlineSupportText}
            />
            {errors.hotlineSupportText && (
              <p className={styles.errorMessage}>{errors.hotlineSupportText}</p>
            )}
          </label>
        </Col>
      </Row>
      {mode === "update" && (
        <Row className="mb-4">
          <Col md={6} className={styles.inputDiv}>
            <DropDown
              label="Status"
              name="status"
              value={formData.status}
              data={["ACTIVE", "INACTIVE"]}
              onChange={(val) => onDropdownChange("status", val)}
              placeholder="Select Status"
              required={false}
              error={!!errors.status}
              helperText={errors.status}
            />
          </Col>
          <Col md={6} className={styles.inputDiv}>
            <label>
              Comment <span className={styles.required}>*</span>
              <textarea
                placeholder="Enter comment"
                name="comment"
                className={styles.textArea}
                onChange={onChange}
                value={formData.comment || ""}
              />
              {errors.comment && (
                <p className={styles.errorMessage}>{errors.comment}</p>
              )}
            </label>
          </Col>
        </Row>
      )}

      <Row className="mb-4">
        <Col md={12}>
          <h5 style={{ marginBottom: "10px", color: "white" }}>
            Plan Settings
          </h5>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={3} className={styles.checkboxDiv}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="subscriptionFlg"
              checked={formData.subscriptionFlg}
              onChange={onChange}
              className={styles.checkbox}
            />
            <span className={styles.checkboxText}>Subscription Flag</span>
          </label>
        </Col>
        <Col md={3} className={styles.checkboxDiv}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="planOverrideFlg"
              checked={true}
              onChange={onChange}
              disabled
              className={styles.checkbox}
            />
            <span className={styles.checkboxText}>Plan Override Flag</span>
          </label>
        </Col>
        <Col md={3} className={styles.checkboxDiv}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="defaultPlanFlg"
              checked={formData.defaultPlanFlg}
              onChange={onChange}
              className={styles.checkbox}
            />
            <span className={styles.checkboxText}>Default Plan Flag</span>
          </label>
        </Col>
        <Col md={3} className={styles.checkboxDiv}>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="strikePriceFlg"
              checked={formData.strikePriceFlg}
              onChange={onChange}
              className={styles.checkbox}
            />
            <span className={styles.checkboxText}>Strike Price Flag</span>
          </label>
        </Col>
      </Row>

      {errors.form && (
        <Row className="mb-3">
          <Col md={12}>
            <div
              className={styles.errorMessage}
              style={{ textAlign: "center", fontSize: "14px" }}
            >
              {errors.form}
            </div>
          </Col>
        </Row>
      )}
      {successMessage && (
        <Row className="mb-3">
          <Col md={12}>
            <div
              className={styles.successMessage}
              style={{ textAlign: "center", fontSize: "14px", color: "green" }}
            >
              {successMessage}
            </div>
          </Col>
        </Row>
      )}

      <Row style={{ marginTop: "30px" }}>
        <Col md={12} className={styles.buttonContainer}>
          <div className={styles.centeredButtons}>
            <div>
              <Button onClick={onPreviousStep} title="Previous" />
            </div>
            <div>
              <Button
                onClick={onSubmit}
                disabled={loading || successMessage !== ""}
                loading={loading}
                title={mode === "create" ? "Create Plan" : "Update Plan"}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );

  return (
    <div className={styles.formContainer}>
      <div className={styles.createPlanContainer}>
        {currentStep === 1 ? renderStepOne() : renderStepTwo()}
      </div>
    </div>
  );
};

export default CreatePlanForm;
